import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand, faCompress } from '@fortawesome/free-solid-svg-icons';
import clicksound from './music/click.mp3';

const ButtonFull = ({ isFullscreen, onClick }) => {
  const handleClick = () => {
    // Buat instance dari Audio dan mainkan sound effect
    const audio = new Audio(clicksound);
    audio.play();

    // Panggil fungsi onClick yang diberikan melalui props
    onClick();
  };

  return (
    <button className="fullscreen-btn lg:w-14 lg:h-14 sm:w-10 sm:h-10" onClick={handleClick}>
      <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} className='lg:text-2xl sm:text-xl'/>
    </button>
  );
};

export default ButtonFull;
